module.exports = __webpack_public_path__ + "static/media/loadingRating.ee782c38.svg";